<!--
  备份以前的页面
   <template>
  <div class="home">
    <Head :logo="logo"></Head>
    <van-form>
      <van-field
        v-model="clientIdCard"
        label="客户证件号码"
        label-class="formTitle"
        label-width="120px"
        placeholder="请输入客户证件号码"
      />
    </van-form>

    <van-button
      round
      block
      type="info"
      native-type="submit"
      @click="search"
      class="btn"
      >查询</van-button
    >
    <PrivacyDialog person='1'
     ref='privacyDialog'
     @goNextAction="goNextAction"
      @getReadState='getReadState' ></PrivacyDialog>
    <Foot
      v-if="
        footList && footList.bottomMessage && footList.bottomMessage.length > 0
      "
      :list="footList"
    ></Foot>
  </div>
</template> -->
<template>
  <!-- 查询页 -->
  <div class="white_bg">
    <div class="bindStudent">
      <div class="top">
        <div class="boxd">
          <img :src="logo" alt />
        </div>
        <img class="rightLogo" src="../../assets/img/rzdbself.png" alt />
      </div>
      <div class="companyname">
        {{ sponsor ? sponsor : "北京博思致新互联网科技有限责任公司" }}
      </div>
      <div class="center">
        <van-form>
          <div>
            <div class="fieldBox">
              <img src="../../assets/img/tyname.png" alt />
              <van-field
                v-model="clientIdCard"
                placeholder="请输入客户证件号码"
              />
            </div>
          </div>
        </van-form>
        <div style="margin-bottom: 22px; text-align: center">
          <van-button native-type="submit" @click="search" class="bindBtn">
            查询
            <img class="blueSha" src="../../assets/img/blueshadow.png" alt />
          </van-button>
        </div>
        <div class="pri">
          <van-checkbox v-model="isRead" shape="square" label-disabled>
            <span @click="isRead = !isRead">勾选即代表我已阅读并同意</span>
            <span @click="toNotice">《用户隐私政策》</span>
          </van-checkbox>
        </div>
        <!-- color更多字体颜色 -->
        <!-- state使用什么颜色的喇叭 1-绿色  2-蓝色 -->
        <CustomFoot
          :typeName="'12'"
          :isHome="true"
          class="zdyfooter"
          color="#297bf4"
          state="2"
        >
          <div class="btn_shadow notice_box_foot">
            确认
            <span></span>
          </div>
        </CustomFoot>
      </div>
    </div>
  </div>
</template>
<script>
import Head from "@/components/head";
import Foot from "@/components/foot";
import { Dialog } from "vant";
import { isEmpty, savePrivacy } from "../../utils/common";
import PrivacyDialog from "@/components/dialog/privacyDialog";
import CustomFoot from "@/components/customFoot";

export default {
  name: "Home",
  components: {
    Head,
    Foot,
    PrivacyDialog,
    CustomFoot,
  },
  data() {
    return {
      fromtype: "2",
      isRead: false,
      showD: false,
      logo: "",
      footList: [],
      vde: "",
      clientIdCard: "",
      isRead: false,
      details: [],
      sponsor: "",
    };
  },
  created() {
    this.vde = this.$route.query.vde ? this.$route.query.vde : "";
    this.getHeadImg();
    this.getFootData();
  },
  activated() {
    // console.log(this.$route.query?.isRead);
    let state = this.$route.query?.isRead;
    this.isRead = state == 1 ? true : false;
    if (this.isRead) {
      this.search();
    }
  },
  methods: {
    toNotice() {
      this.$router.push({
        path: "/financing/notice",
        query: {
          person: "1",
          headerText: "通知",
          params: this.$route.query,
        },
      });
    },
    // 勾选隐私
    getReadState(isRead, details, type) {
      this.isRead = isRead;
      this.details = details;
    },
    goNextAction(isRead, details, type) {
      this.isRead = isRead;
      this.details = details;
      if (type == 1) {
        this.search();
      }
    },
    // 存储隐私授权接口
    savePrivacy() {
      let savePrivacyData = {
        details: this.details,
        userId: this.clientIdCard,
        userName: this.clientIdCard,
      };
      savePrivacy(savePrivacyData);
    },
    getHeadImg() {
      let data = {};
      data.vde = this.vde;
      this.request({
        url: "/webPortal/websitConfig",
        method: "get",
        params: data,
      }).then((res) => {
        if (res.data.code == 1000 && res.data.result) {
          if (res.data.result.logoUrlLogin) {
            this.logo = res.data.result.logoUrlLogin;
          } else {
            this.logo = require("@/assets/img/logo.png");
          }
          if (res.data.result.logoUrl) {
            this.logo = res.data.result.logoUrl;
          } else {
            this.logo = require("@/assets/img/logo.png");
          }
          if (res.data.result.logoName) {
            this.sponsor = res.data.result.logoName;
          }
          sessionStorage.setItem("logoImg", this.logo);
          sessionStorage.setItem("title", res.data.result.websitTitle);
          document.title = sessionStorage.getItem("title");
        } else if (res.data.code != 1000) {
          this.$router.push({ path: "/404" });
        }
      });
    },
    // 获取底部数据
    getFootData() {
      let data = {
        vde: this.vde,
        type: 12,
      };
      this.request({
        url: "/systemManage/mobileGetMessage",
        method: "get",
        params: data,
      }).then((res) => {
        if (res.data.code == 1000) {
          this.footList = res.data.result;
        } else {
        }
      });
    },
    search() {
      if (this.isRead == false) {
        // this.$refs.privacyDialog.open();
        this.$router.push({
          path: "/financing/notice",
          query: {
            person: "1",
            headerText: "通知",
            params: this.$route.query,
          },
        });
        return;
      }
      let testIdcard =
        /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)|(^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$)/;
      if (isEmpty(this.clientIdCard)) {
        this.$CDialog({
          confirmBtnText: "确定", //按钮文字
          title: "提示", //title提示文字
          message: "请输入客户证件号码", //弹窗内容
          status: "2", //显示哪种图   1 为绿色   2为蓝色
          textSize: "16", // 字体大小，默认12
        }).then((res) => {});
      } else if (
        !testIdcard.test(this.clientIdCard) &&
        !isEmpty(this.clientIdCard)
      ) {
        this.$CDialog({
          confirmBtnText: "确定", //按钮文字
          title: "提示", //title提示文字
          message: "客户证件号码格式不正确", //弹窗内容
          status: "2", //显示哪种图   1 为绿色   2为蓝色
          textSize: "16", // 字体大小，默认12
        }).then((res) => {});
      } else {
        this.savePrivacy();
        this.$router.push({
          path:
            "/financing/userResult?clientIdCard=" +
            this.clientIdCard +
            "&vde=" +
            this.vde,
        });
      }
    },
  },
};
</script>


<style lang="scss" scoped>
// .home {
//   background: rgba(247, 247, 247, 1);
//   padding: 0 2vw;
//   box-sizing: border-box;
//   margin-top: 10px;
//   .van-form {
//     background: rgba(255, 255, 255, 1);
//     box-shadow: 4px 4px 5px 0px rgba(51, 51, 51, 0.05);
//     border-radius: 5px;
//   }
//   .van-cell {
//     background: transparent;
//   }
//   .formTitle {
//     padding-right: 40px;
//     text-align-last: justify;
//   }
//   .btn {
//     margin-top: 30px;
//   }
// }
.notice_box_foot {
  background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
  border-radius: 22px;
  margin: 0 19px;
  height: 46px;
  line-height: 46px;

  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
}
.btn_shadow,
.notice_box_foot {
  position: relative;
  > span {
    position: absolute;
    width: 90%;
    background: url("../../assets/other/blueshadow.png") 0 0 no-repeat;
    background-size: 100% 100%;
    border-radius: 0.58667rem;
    height: 0.96rem;
    left: 50%;
    margin-left: -45%;
    bottom: -19px;
    z-index: 0;
  }
}
#captcha {
  position: relative;
  width: 106px;
  height: 40px;
  right: 18px;
}
.mainbox {
  padding: 0 2vw;
  box-sizing: border-box;
  .van-form {
    background: rgba(255, 255, 255, 1);
    box-shadow: 4px 4px 5px 0px rgba(51, 51, 51, 0.05);
    border-radius: 5px;
  }
  .van-cell {
    background: transparent;
  }
  .formTitle {
    padding-right: 40px;
    text-align-last: justify;
  }
  .code {
    overflow: hidden;
    white-space: nowrap;
    .van-cell {
      width: 60% !important;
      float: left;
    }
    img {
      width: 112px;
      height: 44px;
      float: right;
    }
  }
  .van-dialog__message {
    font-size: 15px !important;
    padding: 15px 10px !important;
  }
  .savePass {
    margin: 12px 14px !important;
    display: flex;
    align-items: center;
    > span {
      color: #bfbfbf !important;
      margin-right: 16px;
    }
    ::v-deep .van-checkbox__icon {
      height: 15px;
      line-height: 15px;
    }
    ::v-deep .van-checkbox__icon .van-icon {
      width: 15px;
      height: 15px;
      border: 1px solid #1989fa;
    }
    ::v-deep .van-checkbox__label {
      color: #1989fa;
    }
    ::v-deep .van-checkbox__icon--checked .van-icon {
      line-height: 15px;
    }
  }
  .btnBox {
    position: relative;
    .slideVerifyBox {
      position: absolute;
      background: #fff;
      box-shadow: 0 2px 12px 0 #666;
      bottom: -100px;
      left: 20px;
      z-index: 9999;
    }
  }
}

.white_bg {
  background: #fff;
  min-height: 100vh;
}
.bindStudent {
  background: url("../../assets/img/backi.png") no-repeat;
  background-size: 110% 100%;
  height: 70vh;
  .companyname {
    ;
    font-size: 20px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 700;
    text-align: left;
    padding-left: 26px;

    margin-bottom: 16px;
  }
  .top {
    height: 200px;
    display: flex;
    align-items: flex-end;
    .boxd {
      width: 80px;
      height: 80px;
      background: #fff;
      border-radius: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 24px;
      margin-bottom: 20px;
      //todo logo
      > img {
        width: 79px;
      }
    }
    .rightLogo {
      display: block;
      width: 212px;
      height: 186px;
      margin: 0px auto;
    }
  }

  .center {
    margin-top: 10px;
    background: url("../../assets/img/blcard.png") no-repeat;
    background-size: 100% 100%;
    padding-top: 20px;
    .remarkBox {
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      height: 212px;
      width: 325px;
      margin: 14px auto;
      .boxTop {
        padding: 5px 10px;
        padding-top: 0px;
        display: flex;
        align-items: center;
        > img {
          width: 56px;
          height: 56px;
          margin-left: -10px;
        }
        .remkNotice {
          width: 255px;
          margin-left: 15px;
          margin-bottom: 10px;

          font-size: 16px;
          color: #464a4c;
          letter-spacing: 0;
          font-weight: 500;
          display: flex;
          justify-content: space-between;
          padding-right: 10px;
        }
      }
      .hr {
        width: 285px;
        margin: 0 auto;
        height: 1px;
        background: #f0f0f0;
        padding-left: 10px;
        padding-right: 10px;
        margin-top: -12px;
      }
      ::v-deep .van-field__control::-webkit-input-placeholder {

        font-size: 16px;
        color: rgba(70, 74, 76, 0.7);
        letter-spacing: 0;
        font-weight: 500;
      }
    }
    .fieldBox {
      ::v-deep input.van-field__control::-webkit-input-placeholder {

        font-size: 16px;
        color: rgba(70, 74, 76, 0.7);
        letter-spacing: 0;
        font-weight: 500;
      }
      ::v-deep .van-field__control {

        font-size: 16px;
        color: #464a4c;
        letter-spacing: 0;
        font-weight: 700;
      }
      margin: 14px auto;
      background: #fff;
      border-radius: 25px;
      width: 325px;
      height: 44px;
      display: flex;

      .wrap {

        font-size: 16px;
        color: #464a4c;
        letter-spacing: 0;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
        padding: 0px 20px;
      }
      .wrapF {
        width: 325px;
        height: 212px;
        background: #fff;
        .wrap {

          font-size: 16px;
          color: #464a4c;
          letter-spacing: 0;
          font-weight: 500;
          display: flex;
          justify-content: space-between;
          width: 100%;
          align-items: center;
          padding: 0px 20px;
        }
      }
      img {
        width: 56px;
        height: 56px;
      }

      ::v-deep .van-field {
        width: 240px !important;
        padding-left: 0px !important;
      }

      .varify {
        width: 150px !important;
      }

      .getVari {

        font-size: 16px;
        color: #208fff;
        letter-spacing: 0;
        font-weight: 500;
        line-height: 44px;
        margin-left: 30px;
      }
    }
  }

  ::v-deep .footNotice {
    padding: 0px 20px;
  }

  ::v-deep .foot {
    margin-bottom: 0px !important;
  }
}
.rem_class {
  padding-left: 24px;
  margin-bottom: 26px;
  ::v-deep .van-checkbox__icon .van-icon {
    border-color: #208fff;
    width: 16px;
    height: 16px;
    line-height: 14px;
  }
  ::v-deep .van-checkbox__icon {
    width: 16px;
    height: 16px;
  }
  ::v-deep .van-icon-success::before {
    height: 16px;
    width: 16px;
    padding-right: 2px;
    box-sizing: border-box;
    line-height: 1;
    font-size: 14px;
  }
  ::v-deep .van-checkbox__label {

    font-size: 14px;
    color: #464a4c;
    letter-spacing: 0;
    line-height: 12px;
    font-weight: 400;
  }
}
.bindBtn {
  background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
  width: 326px;
  height: 50px;
  border-radius: 27px;
  font-size: 20px;
  color: #fff;
  font-weight: 700;

  color: #ffffff;
  letter-spacing: 0;
  font-weight: 700;
  position: relative;
  border: none !important;
  outline: none !important;
  ::v-deep .van-button::before {
    border: none;
  }
  .blueSha {
    width: 296px;
    height: 34px;
    position: absolute;
    left: 50%;
    top: 68%;
    transform: translateX(-50%);
  }
  // box-shadow: 0px 6px 2px #208FFF;
}

.pri {
  // margin:0 auto;
  // text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -16px;
  // padding-left: 12px;
  span:nth-of-type(1) {

    font-size: 14px;
    color: #464a4c;
    letter-spacing: 0;
    line-height: 12px;
    font-weight: 400;
  }
  span:nth-of-type(2) {

    font-size: 14px;
    color: #208fff;
    letter-spacing: 0;
    line-height: 12px;
    font-weight: 700;
  }
  ::v-deep .van-checkbox__icon .van-icon {
    border-radius: 4px;
    border-color: #208fff;
  }
}
.noReg {
  margin-top: 23px;

  font-size: 12px;
  color: #464a4c;
  letter-spacing: 0;
  line-height: 18px;
  font-weight: 400;
  text-align: center;
  > span {

    font-size: 12px;
    color: #208fff;
    letter-spacing: 0;
    line-height: 18px;
    font-weight: 700;
  }
}
.zdyfooter {
  padding: 0px 28px;
  margin-top: 30px !important;
}
.notice_foot {
  background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
  border-radius: 22px;
  margin: 0 19px;
  height: 46px;
  line-height: 46px;

  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
}
.btn_shadow,
.notice_box_foot {
  position: relative;
  > span {
    position: absolute;
    width: 90%;
    background: url("../../assets/img/blueshadow.png") 0 0 no-repeat;
    background-size: 100% 100%;
    border-radius: 0.58667rem;
    height: 0.96rem;
    left: 50%;
    margin-left: -45%;
    bottom: -19px;
    z-index: 0;
  }
}
</style>
